module.exports = __webpack_public_path__ + "img/jieshi.41fadf73.svg";